import { render, staticRenderFns } from "./ProjectsComponent.vue?vue&type=template&id=6f9eb1e1&scoped=true"
import script from "./ProjectsComponent.vue?vue&type=script&lang=js"
export * from "./ProjectsComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectsComponent.vue?vue&type=style&index=0&id=6f9eb1e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9eb1e1",
  null
  
)

export default component.exports